import Markdown from 'react-markdown'
import { MarkdownCardConfig, CardData } from '../types'
import { MermaidRenderer } from '../../MdTextComponent/MermaidRenderer'
import remarkGfm from 'remark-gfm'
import { cn } from '@/lib/utils'

export function MarkdownCard({ config, data }: { config: MarkdownCardConfig; data: CardData }) {
  const proseVariant = config.fontSize === 'sm' ? 'prose-sm' : config.fontSize === 'lg' ? 'prose-lg' : 'prose-md'
  return (
    <div className="flex h-full w-full items-center justify-center">
      <div className={cn('prose max-w-none dark:prose-invert', proseVariant)}>
        <Markdown
          remarkPlugins={[remarkGfm]}
          components={{
            pre({ children, ...props }) {
              // Check if this pre contains a code block with mermaid
              const codeElement = children as React.ReactElement
              if (codeElement?.props?.className?.includes('language-mermaid')) {
                return <MermaidRenderer chart={String(codeElement.props.children).replace(/\n$/, '')} />
              }
              return <pre {...props}>{children}</pre>
            },
            code({ className, children, ...props }) {
              // For inline code or non-mermaid code blocks
              return (
                <code className={className} {...props}>
                  {children}
                </code>
              )
            },
          }}
        >
          {data.markdown}
        </Markdown>
      </div>
    </div>
  )
}
